import { rest } from 'msw';

export default [
    rest.all('https://www.datadoghq-browser-agent.com', (req, res, ctx) => {
        console.log('------- DATADOG MSW INTERCEPT ------- ', req.params);

        return res(ctx.status(200));
    }),
    rest.get('http://www.google-analytics.com/*', (req, res, ctx) => {
        console.log('------- GOOGLE ANALYTICS MSW INTERCEPT ------- ', req.params);

        return res(ctx.status(200));
    }),
    rest.get(/heapanalytics/, (req, res, ctx) => {
        console.log('------- GOOGLE ANALYTICS HEAP INTERCEPT ------- ', req.params);

        return res(ctx.status(200));
    }),
];
